import { PostQboAccounts } from '../../domain/usecases/post-qbo-accounts';
import { BaseHttpService } from 'main/factories/http';

export class RemotePostQboAccounts extends BaseHttpService<PostQboAccounts.Model> implements PostQboAccounts {
  async updateAccounts(body: PostQboAccounts.Body): Promise<PostQboAccounts.Model> {
    return await this.request('post', body);
  }
}
